// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1kZIc","content":"Consent_content__1BD0f","footer":"Consent_footer__3Vnpj"};